import styles from './inputGroup.module.css'
import { TextField } from '../text-field/textField'
import { NumberField } from '../number-field/numberField'
import { FieldType, TextOrNumber } from '../../types'
import { O } from '../../../state/types'

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
    id: string
    inputKey?: string
    type?: FieldType
    value?: TextOrNumber
    defaultValue?: TextOrNumber
    min?: number
    max?: number
    preLabel?: string
    postLabel?: string
    integer?: boolean
    round?: boolean
    optional?: boolean
    fit?: boolean
    thousandsSeparator?: boolean
    className?: string
    onChange?: (value?: TextOrNumber) => void
}

export const InputGroup = (props: Props) => {
    const { id, inputKey, type = FieldType.NUMBER, value, defaultValue, min, max, preLabel, postLabel, optional, fit, thousandsSeparator, className, onChange, ...rest } = props

    const renderField = () => {
        const radiusClass = `${preLabel ? styles.noLeftRadius : ''} ${postLabel ? styles.noRightRadius : ''}`
        const fieldClassName = `${styles.field} ${radiusClass}`

        if (type === FieldType.TEXT) {
            return <TextField
                id={id}
                inputKey={inputKey}
                value={value as O<string>}
                defaultValue={defaultValue as O<string>}
                freeValue={true}
                optional={optional}
                className={fieldClassName}
                onChange={onChange}
                {...rest}
            />
        } else if (type === FieldType.NUMBER) {
            return <NumberField
                id={id}
                inputKey={inputKey}
                value={value as O<number>}
                defaultValue={defaultValue as O<number>}
                min={min}
                max={max}
                optional={optional}
                fit={fit}
                thousandsSeparator={thousandsSeparator}
                className={fieldClassName}
                onChange={onChange}
                {...rest}
            />
        }
    }

    return (
        <div className={`input-group ${styles.container} ${className || ''}`}>
            {preLabel && <span className="input-group-text">{preLabel}</span>}
            {renderField()}
            {postLabel && <span className="input-group-text">{postLabel}</span>}
        </div>
    )
}
